import { Position } from "../types";

// Haversine 공식으로 두 좌표 사이 거리 계산 (미터)
export const calculateDistance = (pos1: Position, pos2: Position): number => {
  const R = 6371000; // 지구 반지름 (미터)
  const dLat = toRad(pos2.lat - pos1.lat);
  const dLng = toRad(pos2.lng - pos1.lng);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(pos1.lat)) *
      Math.cos(toRad(pos2.lat)) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};

const toRad = (deg: number): number => deg * (Math.PI / 180);

export const calculateTotalDistance = (positions: Position[]): number => {
  if (positions.length < 2) return 0;

  let total = 0;
  for (let i = 1; i < positions.length; i++) {
    total += calculateDistance(positions[i - 1], positions[i]);
  }
  return total;
};
